module.exports = __webpack_public_path__ + "static/media/content.946356ca.jpg";